import { Failure } from '@geekbears/gb-ngrx-stack-base';

export class CacheableState<T> {
  data?: T | null;
  loading?: boolean;
  failure?: Failure | null;

  constructor(data?: CacheableState<T> | null) {
    this.data = data?.data ?? null;
    this.loading = data?.loading ?? false;
    this.failure = null;
  }
}
